import { ILanguage } from '@/interfaces/languages';
import { track } from '@/shared/analytics';
import React from 'react';

interface Props {
  languages: ILanguage[];
  currentLanguage: ILanguage;
  currentPath: string;
}

const LanguageList = (props: Props) => {
  const { languages, currentLanguage, currentPath } = props;

  const getPathWithLang = (lang: string, currentPath: string) => {
    let path = '';

    if (lang !== 'pt-br') {
      path = `${path}/${lang}`;
    }

    if (!currentPath.startsWith('/')) {
      path = path + '/';
    }

    return `${path}${currentPath}`;
  };

  return (
    <ul
      id="responsive-navbar-languages"
      className="anim-drop-down responsive-navbar-languages other-languages"
    >
      {languages.map((language, index) =>
        language.lang !== currentLanguage.lang ? (
          <a
            href={getPathWithLang(language.lang, currentPath)}
            data-lang={language.lang}
            className="anim-drop-down-item language"
            onClick={() => {
              track('languageChange', { template: 'virgoA', language: language.lang });
            }}
            key={index}
          >
            <img src={language.icon} alt={`${language.lang}`} />
            <p>{language.lang.toUpperCase()}</p>
          </a>
        ) : null
      )}
    </ul>
  );
};

export default LanguageList;
